/**
 * Format a monetary amount stored as INTEGER MINOR UNITS (e.g. cents) into a
 * localised currency string. Returns the empty string when the amount is
 * null/undefined so callers can interpolate without conditional logic.
 *
 * Keep in sync with the backend twin at `src/shared/format/money.ts` — they
 * live in separate build graphs so we can't import one from the other.
 */

export function formatMoney(
  minor: number | null | undefined,
  currency: string,
  locale = 'es-ES',
): string {
  if (minor === null || minor === undefined) return '';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(minor / 100);
}
